export function formatUSPhoneNumber(phone) {
    // Check for +1 followed by 10 digits
    const match = phone.match(/^\+1(\d{10})$/);
    if (match) {
        const num = match[1];
        return `+1 ${num.slice(0, 3)}-${num.slice(3, 6)}-${num.slice(6)}`;
    }
    return phone;
}
